import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "../../icons/Icon";
import { Carregando, Aviso } from "../../components/Layout";
import { api, fmt, type InscricaoResumo } from "../../lib/api";

const ROTULO_STATUS: Record<string, string> = {
  RECEBIDA: "Recebida", EM_ANALISE: "Em análise", DEFERIDA: "Deferida",
  INDEFERIDA: "Indeferida", CLASSIFICADA: "Classificada", CONVOCADA: "Convocada",
  CONTRATADA: "Contratada", ELIMINADA: "Eliminada",
};

export function MinhasInscricoes() {
  const [inscricoes, setInscricoes] = useState<InscricaoResumo[] | null>(null);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    api.get<InscricaoResumo[]>("/api/candidato/inscricoes")
      .then(setInscricoes)
      .catch(() => setErro("Não foi possível carregar as suas inscrições."));
  }, []);

  return (
    <div className="pilha pilha-6">
      <div className="linha linha-entre linha-quebra">
        <h1 className="h2">Minhas inscrições</h1>
        <Link to="/area/nova-inscricao" className="tc-btn tc-btn-primario">
          <Icon nome="editar" tamanho={18} />
          Nova inscrição
        </Link>
      </div>

      {erro && <Aviso tipo="erro">{erro}</Aviso>}

      {!inscricoes && !erro && <Carregando texto="Carregando as suas inscrições" />}

      {inscricoes && inscricoes.length === 0 && (
        <div className="tc-lista-vazia">
          <p>Você ainda não tem nenhuma inscrição.</p>
          <p className="tc-ajuda" style={{ marginTop: 8 }}>
            O item 8.9 do edital permite até 5: 3 para Educador de Educação Básica, 1 para
            Educador Especialista Pedagógico e 1 para Monitor.
          </p>
        </div>
      )}

      {inscricoes && inscricoes.length > 0 && (
        <div className="tc-grade-inscricoes">
          {inscricoes.map((i) => (
            <Link key={i.id} to={`/area/inscricoes/${i.id}`} className="tc-cartao"
                  style={{ textDecoration: "none", color: "inherit" }}>
              <span className={`tc-badge tc-badge-${i.status.toLowerCase()}`}>
                {ROTULO_STATUS[i.status] ?? i.status}
              </span>
              <strong style={{ display: "block", marginTop: 8 }}>{i.cargo}</strong>
              {i.componente && <span className="tc-ajuda">{i.componente}</span>}
              <div className="linha linha-entre" style={{ marginTop: 12 }}>
                <span className="tc-ajuda">{fmt.data(i.enviadaEm)}</span>
                <strong className="num">{fmt.pontos(i.pontosTotal)} pts</strong>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
